import { Popover, Progress } from "antd";
import { MESSAGE_STATUS } from "../../config/Constant";
import { getFileIcon } from "../../utils/SendFile";
import { standardizeVolume } from "../../utils/Utils";
import MediaViewerModal from "../modal/MediaViewerModal";
import { useResourceViewer } from "../customHook/ResourceViewer";
import { DeleteOutlined } from "@ant-design/icons";
import { useMenuContext } from "../../context/MenuContext";

const VideoFile = ({
  requestUuid,
  file,
  contentType,
  percentProgress,
  totalVolume,
  cancelUpload,
}) => {
  const resourceViewer = useResourceViewer();
  const { selectedConversation } = useMenuContext() || {};

  return (
    <>
      <button
        className="w-full"
        onClick={() => resourceViewer?.handleOpenViewer(file, file?.createdAt)}
      >
        <div className="max-h-[300px] flex flex-row my-1 items-center">
          {file?.originalName
            ? getFileIcon(file?.originalName)
            : file?.originalName}
          <div className="flex flex-col items-start">
            <Popover content={file?.originalName}>
              <div className="file-short-name">{file?.originalName}</div>
            </Popover>
            {contentType === MESSAGE_STATUS.FILE && (
              <div className="text-[grey] text-[12px]">
                {file?.volume && standardizeVolume(file?.volume)}
              </div>
            )}
            {contentType === MESSAGE_STATUS.CHUNK && (
              <div className="text-[grey] text-[12px]">
                {standardizeVolume((percentProgress * totalVolume) / 100)} /
                {standardizeVolume(totalVolume)}
              </div>
            )}
          </div>
        </div>

        {contentType === MESSAGE_STATUS.CHUNK && (
          <div className="flex justify-center items-center">
            {percentProgress === 0 ||
            percentProgress === 1 ||
            !percentProgress ? (
              <div className="progress-container">
                <div className="progress-bar" />
              </div>
            ) : (
              <Progress
                percent={percentProgress}
                showInfo={false}
                strokeColor="#52c41a"
                size="small"
              />
            )}
            <DeleteOutlined
              className="ms-2 text-red-500 text-sm p-1 rounded-full hover:bg-blue-200"
              onClick={(e) => {
                e.stopPropagation();
                cancelUpload(selectedConversation?.conversationId, requestUuid);
              }}
            />
          </div>
        )}
      </button>
      {/* Modal viewer */}
      {resourceViewer?.visible && (
        <MediaViewerModal resourceViewer={resourceViewer} />
      )}
    </>
  );
};

export { VideoFile };
